import React from "react";

const STREAM_PROTOCOLS = ["webrtc", "hls", "rtsp", "llhls"];

export default function DeviceList({
  devices,
  streamModes,
  onChangeStreamMode,
  onOpen,
  onEdit,
  onDelete,
  onAdd,
}) {
  return (
    <div className="device-list">
      <div className="title-row">
        <div>
          <h3>Device Sensors</h3>
          <p className="section-subtitle">Manage all cameras, stream types, and quick actions</p>
        </div>
        <button className="primary-btn" onClick={onAdd}>
          Add Device
        </button>
      </div>

      <div className="device-grid">
        {devices.map((dev) => {
          const name = dev.deviceName || dev.name || `Device ${dev.id}`;
          const source = dev.ipAddress || "test.mp4";
          const selectedMode = streamModes[dev.id] || "webrtc";
          return (
            <div key={dev.id} className="device-item">
              <div className="device-card-head">
                <div className="device-name">{name}</div>
                <span className="device-id-badge">#{dev.id}</span>
              </div>

              <div className="device-meta-row">
                <span className="meta-key">Source</span>
                <span className="meta-value" title={source}>
                  {source}
                </span>
              </div>

              <div className="device-meta-row">
                <span className="meta-key">Stream</span>
                <select
                  className="stream-select"
                  value={selectedMode}
                  onChange={(e) => onChangeStreamMode(dev.id, e.target.value)}
                >
                  {STREAM_PROTOCOLS.map((mode) => (
                    <option key={mode} value={mode}>
                      {mode.toUpperCase()}
                    </option>
                  ))}
                </select>
              </div>

              <div className="actions-row card-actions">
                <button onClick={() => onOpen(dev)}>Open</button>
                <button onClick={() => onEdit(dev)}>Edit</button>
                <button className="danger" onClick={() => onDelete(dev)}>
                  Delete
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

